import "./App.css";
import React, { useEffect, useState } from "react";
import { Routes, Route, BrowserRouter, useLocation } from "react-router-dom";
import Cookies from "universal-cookie";
import SideMenu from "./SideMenu/SideMenu";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
import { toast, ToastContainer } from "react-toastify";
import { Box, Typography } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import "react-toastify/dist/ReactToastify.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import "./assets/css/test1.css";
// import rtlPlugin from "stylis-plugin-rtl";
// import createCache from "@emotion/cache";
import { setUserToken } from "./reduxStore/UserReducer";
import { setscreenwidth } from "./reduxStore/SettingsReducer";
import { Slide } from "react-toastify";
import {
  Dashboard,
  Login,
  LogTable,
  CustomerCareTasksTable,
  InstallationTasksTable,
  TasksTable,
  Tasks,
  TaskSummaryDashboard,
  CustomerCarTaskReport,
  Users,
  Departmant,
  TaskType,
  RequestType,
  Complain,
  MizanListStatus,
  DefaultSetting,
  UnavailableResources,
  DailyPlan,
  CreateMission,
  MissionsTable,
  MissionAndSubMissionPage,
  MissionDetails,
  Notification,
  Profile,
  LeaveRequest,
  InventoryRequest,
  UserOverTime,
  CarInspections,
  SubMissionOverTime,
  CarInspectionsQuestions,
  CarInspectionsCategories,
  DetialsTaskEdit2,
  File,
  Classification,
  ClassificationLevel1,
  ClassificationLevel2,
  ClassificationLevel3,
  ClassificationLevel4,
  VehicleMaster,
  ClassificationTreeView,
  DNDMissions,
  GroupsComponent,
  UpdateContent,
  ImageSubmissionType,
  SubmissionImageType,
  SubmissionType,
  FileManager,
  FinanceType,
  FinancesTabs,
  FinanceTaskDetails,
  UnitsTransferTabs,
  Attendances,
  TransferNotification,
  WarshaPlanning
} from "./Pages/index";
import ProtectionAdmin from "./Pages/ProtectAdmin";
import RedirectPages from "./Pages/RedirectPages/RedirectPages";
import DetialsTaskEdit from "./Pages/Tasks/DetialsTaskEdit";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import { setMainTranslation } from "./reduxStore/TranslateReducer";
import WelcomePage from "./Pages/WelcomePage";
// import { CacheProvider } from "@emotion/react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import host from "./assets/js/Host";

const cookies = new Cookies();

const MINUTE_MS = 60000;

function App() {
  const dispactch = useDispatch();
  const location = useLocation();
  const directions = useSelector(state => state.settingsData.directions);
  const languageCode = useSelector(state => state.settingsData.code);

  const Translate_ar = useSelector(state => state.translateData.translation_ar);
  const Translate_en = useSelector(state => state.translateData.translation_en);
  const maintheme = useSelector(state => state.themeData.maintheme);
  const [newVersionAvailable, setNewVersionAvailable] = React.useState(false);
  const dispatch = useDispatch();
  const token = cookies.get("token");
  const { version } = require("../package.json");

  useEffect(() => {
    if (token) {
      dispatch(setUserToken(token));
    }
  }, [token]);

  const [theme, setTheme] = useState(
    createTheme({
      direction: directions, // Both here and <body dir="rtl">
      palette: {
        primary: {
          main: "#1e6a99"
        },
        secondary: {
          main: "#fff"
        }
      }
    })
  );

  useEffect(() => {
    dispactch(setMainTranslation(directions == "rtl" ? Translate_ar : Translate_en));
    setTheme(
      createTheme({
        direction: "ltr", // Both here and <body dir="rtl">
        palette: {
          primary: {
            main: "#1e6a99"
          },
          secondary: {
            main: "#fff"
          }
        }
      })
    );
  }, [directions]);

  useEffect(() => {
    if (cookies.get("user_id") && !localStorage.getItem("@USERCURRENTDATE" + cookies.get("user_id"))) {
      localStorage.setItem("@USERCURRENTDATE" + cookies.get("user_id"), new Date());
    }
    if (!localStorage.getItem("roles") || JSON.parse(localStorage.getItem("roles"))?.length <= 0) {
      let arr = [0];
      localStorage.setItem("roles", JSON.stringify(arr));
    }
    window.addEventListener("resize", () => {
      dispatch(setscreenwidth(window.innerWidth));
    });
  }, []);

  function isServerVersionHigher(serverVersion, clientVersion) {
    const serverParts = serverVersion.split(".").map(Number);
    const clientParts = clientVersion.split(".").map(Number);

    for (let i = 0; i < serverParts.length; i++) {
      if (serverParts[i] > clientParts[i]) {
        return true;
      } else if (serverParts[i] < clientParts[i]) {
        return false;
      }
    }

    return false;
  }

  useEffect(() => {
    (async () => {
      try {
        const headers = {
          jwt: cookies.get("token")
        };
        await axios({
          url: host + "update_contents/last_version",
          method: "GET",
          headers: headers
        })
          .then(res => {
            const server_version = res.data.data.version;
            if (isServerVersionHigher(server_version, version)) {
              setNewVersionAvailable(true);
            } else {
              setNewVersionAvailable(false);
            }
          })
          .catch(e => {
            console.log("Error Version retrieving", e);
          });
      } catch (error) {
        console.log("Error: ", error);
      }
    })();
  }, [location.pathname]);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%"
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: newVersionAvailable ? 0 : "-30px",
          left: 0,
          width: "100vw",
          height: "30px",
          bgcolor: "#FF7777FF",
          zIndex: 10000000,
          transition: "0.2s ease-in-out"
        }}
      >
        <Box
          sx={{
            flex: 1,
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative"
          }}
        >
          <Typography sx={{ color: "#fff" }}>New version is available, please refresh this page</Typography>
          <CloseIcon
            sx={{
              position: "absolute",
              top: "50%",
              right: "20px",
              transform: "translate(-50%, -50%)",
              color: "#fff",
              fontSize: "22px",
              cursor: "pointer"
            }}
            onClick={() => setNewVersionAvailable(false)}
          />
        </Box>
      </Box>

      {/* // <I18nextProvider i18n={i18next}> */}
      {/* <CacheProvider value={isrtl}> */}
      <ThemeProvider theme={theme}>
        <ToastContainer containerId="container_toast_id" position="top-center" autoClose={5000} hideProgressBar={true} newestOnTop={false} transition={Slide} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/ticket-system" element={<SideMenu />}>
            <Route
              path={"Dashboard"}
              element={
                <ProtectionAdmin>
                  <Dashboard />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"Users"}
              element={
                <ProtectionAdmin>
                  <Users />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"Department"}
              element={
                <ProtectionAdmin>
                  <Departmant />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"complain"}
              element={
                <ProtectionAdmin>
                  <Complain />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"Task_type"}
              element={
                <ProtectionAdmin>
                  <TaskType />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"Installation"}
              element={
                <ProtectionAdmin>
                  <Dashboard />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"mizan_list_status"}
              element={
                <ProtectionAdmin>
                  <MizanListStatus />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"missions"}
              element={
                <ProtectionAdmin>
                  <MissionAndSubMissionPage />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"general_tasks"}
              element={
                <ProtectionAdmin>
                  <TasksTable />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"installation_tasks"}
              element={
                <ProtectionAdmin>
                  <InstallationTasksTable />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"customer_care_tasks"}
              element={
                <ProtectionAdmin>
                  <CustomerCareTasksTable />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"Tasks"}
              element={
                <ProtectionAdmin>
                  <Tasks />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"unavailable_resources"}
              element={
                <ProtectionAdmin>
                  <UnavailableResources />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"create_mission"}
              element={
                <ProtectionAdmin>
                  <CreateMission />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"daily_plan"}
              element={
                <ProtectionAdmin>
                  <DailyPlan />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"request_types"}
              element={
                <ProtectionAdmin>
                  <RequestType />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"default_settings"}
              element={
                <ProtectionAdmin>
                  <DefaultSetting />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"customers"}
              element={
                <ProtectionAdmin>
                  <Dashboard />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"Notifications"}
              element={
                <ProtectionAdmin>
                  <Notification />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"NoteTask"}
              element={
                <ProtectionAdmin>
                  <Dashboard />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"LogTable"}
              element={
                <ProtectionAdmin>
                  <LogTable />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"Detials_TaskEdit"}
              element={
                <ProtectionAdmin>
                  <DetialsTaskEdit />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"mission_details"}
              element={
                <ProtectionAdmin>
                  <MissionDetails />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"cash_accounts_tasks"}
              element={
                <ProtectionAdmin>
                  <Dashboard />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"view_task"}
              element={
                <ProtectionAdmin>
                  <Dashboard />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"task_summary_dashboard"}
              element={
                <ProtectionAdmin>
                  <TaskSummaryDashboard />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"customer_care_reports"}
              element={
                <ProtectionAdmin>
                  <CustomerCarTaskReport />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"user-profile"}
              element={
                <ProtectionAdmin>
                  <Profile />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"leave-requests"}
              element={
                <ProtectionAdmin>
                  <LeaveRequest />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"car_inspections"}
              element={
                <ProtectionAdmin>
                  <CarInspections />
                </ProtectionAdmin>
              }
            />
            <Route path={"car_inspections_questions"} element={<CarInspectionsQuestions />} />
            <Route path={"car_inspections_categories"} element={<CarInspectionsCategories />} />
            <Route
              path={"inventory-requests"}
              element={
                <ProtectionAdmin>
                  <InventoryRequest />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"user-overtimes"}
              element={
                <ProtectionAdmin>
                  <UserOverTime />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"sub-mission-overtimes"}
              element={
                <ProtectionAdmin>
                  <SubMissionOverTime />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"new-ticket-view"}
              element={
                <ProtectionAdmin>
                  <DetialsTaskEdit2 />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"files"}
              element={
                <ProtectionAdmin>
                  <File />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"classifications"}
              element={
                <ProtectionAdmin>
                  <Classification />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"classifications-level-1"}
              element={
                <ProtectionAdmin>
                  <ClassificationLevel1 />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"classifications-level-2"}
              element={
                <ProtectionAdmin>
                  <ClassificationLevel2 />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"classifications-level-3"}
              element={
                <ProtectionAdmin>
                  <ClassificationLevel3 />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"classifications-level-4"}
              element={
                <ProtectionAdmin>
                  <ClassificationLevel4 />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"vehicle_master"}
              element={
                <ProtectionAdmin>
                  <VehicleMaster />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"classifications-tree-view"}
              element={
                <ProtectionAdmin>
                  <ClassificationTreeView />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"welcome_page"}
              element={
                <ProtectionAdmin>
                  <WelcomePage />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"dnd_missions"}
              element={
                <ProtectionAdmin>
                  <DNDMissions />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"groups"}
              element={
                <ProtectionAdmin>
                  <GroupsComponent />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"update-contents"}
              element={
                <ProtectionAdmin>
                  <UpdateContent />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"image-submission-type"}
              element={
                <ProtectionAdmin>
                  <ImageSubmissionType />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"submission-image-types"}
              element={
                <ProtectionAdmin>
                  <SubmissionImageType />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"submission-types"}
              element={
                <ProtectionAdmin>
                  <SubmissionType />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"file_manager"}
              element={
                <ProtectionAdmin>
                  <DndProvider backend={HTML5Backend}>
                    <FileManager />
                  </DndProvider>
                </ProtectionAdmin>
              }
            />
            <Route
              path={"finances"}
              element={
                <ProtectionAdmin>
                  <FinancesTabs />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"finance_type"}
              element={
                <ProtectionAdmin>
                  <FinanceType />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"financeTaskDetails"}
              element={
                <ProtectionAdmin>
                  <FinanceTaskDetails />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"units_transfer"}
              element={
                <ProtectionAdmin>
                  <UnitsTransferTabs />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"attendances"}
              element={
                <ProtectionAdmin>
                  <Attendances />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"transfer_notification"}
              element={
                <ProtectionAdmin>
                  <TransferNotification />
                </ProtectionAdmin>
              }
            />
            <Route
              path={"warsha_plans"}
              element={
                <ProtectionAdmin>
                  <WarshaPlanning />
                </ProtectionAdmin>
              }
            />
            <Route
              path="*"
              element={
                <ProtectionAdmin>
                  <RedirectPages code={"404"} reason={"Woobs!"} message="The page you are looking for is not currently available" path={"/ticket-system/dashboard"} goTo="Go Home" />
                </ProtectionAdmin>
              }
            />
          </Route>
        </Routes>
      </ThemeProvider>
      {/* </CacheProvider> */}
      {/* // </I18nextProvider> */}
    </Box>
  );
}

export default App;
